import { Select, Space, Typography, Grid } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../../hooks/useTenant';
import { useTenants } from '../../api/queries/useTenants';

const { Text } = Typography;
const { useBreakpoint } = Grid;

export function TenantSelector() {
  const navigate = useNavigate();
  const { tenantId, tenants, setTenantId, isLoading } = useTenant();
  const { isLoading: isLoadingTenants } = useTenants();
  const screens = useBreakpoint();

  const options = tenants.map((tenant) => ({
    value: tenant.id,
    label: tenant.name,
  }));

  const handleTenantChange = (newTenantId: string) => {
    setTenantId(newTenantId);
    navigate('/');
  };

  return (
    <Space>
      <BankOutlined style={{ color: '#fff' }} aria-hidden="true" />
      {screens.sm && (
        <Text
          style={{ color: '#fff' }}
          id="tenant-selector-label"
        >
          Tenant:
        </Text>
      )}
      <Select
        value={tenantId || undefined}
        onChange={handleTenantChange}
        options={options}
        loading={isLoading || isLoadingTenants}
        style={{ minWidth: screens.sm ? 150 : 120 }}
        placeholder="Select tenant"
        aria-label="Select tenant"
        aria-labelledby={screens.sm ? 'tenant-selector-label' : undefined}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
      />
    </Space>
  );
}
